import { render } from "./TrialingComponent.vue?vue&type=template&id=dedec224"
import script from "./TrialingComponent.vue?vue&type=script&lang=js"
export * from "./TrialingComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__